<script setup lang="ts">
import type { SalesQueueSlotsDay } from '../../model/slots-management/interfaces'

import { AppTable, AppTh, AppTr, AppTd } from '@shared/ui/tables'
import { AppInput } from '@shared/ui/inputs'
import { BtnToggle } from '@shared/ui/buttons'

defineOptions({
  name: 'SalesQueueSlotsTable',
})

const props = withDefaults(defineProps<{
  day: SalesQueueSlotsDay
  show?: boolean
}>(), {
  show: false,
})

const toggleSlot = (value: boolean, index: number): void => {
  const slot = props.day.slots[index]
  if (slot) {
    slot.is_enabled = value
  }
}
</script>

<template>
  <div
    v-show="show"
    class="sales-queue-slots-table"
  >
    <AppTable
      class="rounded-table"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh>Demo Time slot</AppTh>
          <AppTh>Demo booked</AppTh>
          <AppTh>Sales calls time slot</AppTh>
          <AppTh>Enable limit</AppTh>
          <AppTh>Agents</AppTh>
          <AppTh>Limit of demo completed</AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="(slot, index) in day.slots"
          :key="slot.time"
        >
          <AppTd>{{ slot.time }}</AppTd>
          <AppTd>{{ slot.demo_booked }}</AppTd>
          <AppTd>{{ slot.sales_queue_time }}</AppTd>
          <AppTd>
            <BtnToggle
              :checked="slot.is_enabled"
              @click="(value) => toggleSlot(value, index)"
            />
          </AppTd>
          <AppTd>
            <AppInput
              v-model="slot.agents_limit"
              type="number"
              :min="0"
              :disabled="!slot.is_enabled"
            />
          </AppTd>
          <AppTd>
            <AppInput
              v-model="slot.completed_limit"
              type="number"
              :min="0"
              :disabled="!slot.is_enabled"
            />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./SalesQueueSlotsTable.scss" />
